import { z } from "zod";

import type { automationFormSchema } from "./hooks/use-automation-form-schema";

export type AutomationFormData = z.infer<typeof automationFormSchema>;

export type AutomationSortValue = "newest" | "oldest" | "a-z" | "z-a";

export const automationSortEnum = z.enum(["newest", "oldest", "a-z", "z-a"]);

export type AutomationListItem = {
  id: string;
  product_id: string;
  product_name: string;
  host: string;
  host_auth: string;
  steps_count?: number;
  created_at: string;
  updated_at: string;
};

export interface AutomationMappingDetail {
  mapping_type: string;
  target_type: string;
  title: string;
  key: string;
  value: string;
  value_type?: string;
}

export interface AutomationStepDetail {
  step_order: number;
  step_type: string;
  name: string;
  method: string;
  endpoint: string;
  content_type: string;
  mappings: AutomationMappingDetail[];
}

export type AutomationStepSummary = {
  step_type: string;
  step_name: string;
  content_type: string;
};

export type AutomationDetailData = {
  id: string;
  product_id: string;
  product_name: string;
  seller_name: string;
  host: string;
  host_auth: string;
  is_active: boolean;
  steps: AutomationStepSummary[];
  created_at: string;
  updated_at: string;
};

export interface AutomationMappingDetail {
  mapping_type: string;
  target_type: string;
  title: string;
  key: string;
  value: string;
  value_type?: string;
}

export interface AutomationStepDetail {
  step_order: number;
  step_type: string;
  name: string;
  method: string;
  endpoint: string;
  content_type: string;
  mappings: AutomationMappingDetail[];
}

export type AutomationEditData = {
  id: string;
  product_id: string;
  product_name: string;
  host: string;
  host_auth?: string;
  auth_type: string;
  auth_header_name: string;
  auth_value_prefix: string;
  token_response_field?: string;
  steps: AutomationStepDetail[];
};
